module.exports = __webpack_public_path__ + "media/images/openstreetmap/ScrollWheel20-8dcefc0d28b60914b4fd0475f43748c9.png";